export function SkeletonCard() {
  return (
    <div className="flex rounded-2xl overflow-hidden" style={{ background: 'var(--glass-bg)', border: '1px solid var(--border-glass)' }}>
      <div className="w-28 shrink-0 h-28 skeleton" />
      <div className="flex-1 p-3 flex flex-col justify-between">
        <div>
          <div className="h-4 rounded-full w-3/4 mb-2 skeleton" />
          <div className="h-3 rounded-full w-1/2 skeleton" />
        </div>
        <div className="flex gap-1 mt-2">
          <div className="h-5 w-14 rounded-full skeleton" />
          <div className="h-5 w-10 rounded-full skeleton" />
        </div>
        <div className="flex justify-between mt-2">
          <div className="h-4 w-20 rounded-full skeleton" />
          <div className="h-3 w-10 rounded-full skeleton" />
        </div>
      </div>
    </div>
  );
}

export function SkeletonCategoryGrid() {
  return (
    <div className="grid grid-cols-2 gap-3">
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className={`rounded-2xl skeleton ${i === 5 ? 'col-span-2 h-32' : 'h-36'}`}
        />
      ))}
    </div>
  );
}

export function SkeletonProductGroup() {
  return (
    <div className="space-y-4">
      <div className="h-[55vw] w-full skeleton" />
      <div className="px-4 space-y-3">
        <div className="h-6 rounded-full w-2/3 skeleton" />
        <div className="h-4 rounded-full w-1/2 skeleton" />
        <div className="flex gap-2 mt-2">
          <div className="h-9 w-28 rounded-2xl skeleton" />
          <div className="h-9 w-28 rounded-2xl skeleton" />
        </div>
        <div className="h-12 rounded-2xl mt-4 skeleton" />
        <div className="h-12 rounded-2xl skeleton" />
        <div className="h-14 rounded-2xl mt-6 skeleton" />
      </div>
    </div>
  );
}
